import script from "./WePlanCard.vue?vue&type=script&setup=true&lang=js"
export * from "./WePlanCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__